import {
    LOGIN_STORE_EMAIL,
    LOGIN_CURRENT_TAB,
    CURRENT_REG_INDEX
} from './actions';

const initialState = {
    email: '',
    tabIndex: 0,
    currentRegIndex: 0
};

export const loginReducer = ( state = initialState, action ) => {

    let result = '';

    switch ( action.type ) {

        case LOGIN_STORE_EMAIL:
            result = { ...state, email: action.payload };
            break;

        case LOGIN_CURRENT_TAB:
            result = { ...state, tabIndex: action.payload };
            break;
        case CURRENT_REG_INDEX:
            result = { ...state, currentRegIndex: action.payload };
            break;
        default:
            return state;

    }

    return result;

};